import { resetLocalAuthKey } from '@/common/auth';
import { useServiceWorker } from '@/common/notifications';
import { useShoppingCart } from '@/contexts';
import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { useCurrentUserQuery } from './graphql.generated';

export const useCurrentUser = ({
	forceRefetch,
	skip,
}: { forceRefetch?: boolean; skip?: boolean } = {}) => {
	const serviceWorker = useServiceWorker();
	const client = useApolloClient();
	const { clearCart } = useShoppingCart();

	const {
		data: userData,
		loading: userLoading,
		error: userError,
		refetch: refetchUser,
	} = useCurrentUserQuery({
		fetchPolicy: forceRefetch ? 'network-only' : 'cache-first',
		skip,
	});

	const logUserOut = useCallback(async () => {
		clearCart();
		resetLocalAuthKey();
		client.clearStore();
		await serviceWorker.unsubscribeAll();
	}, [client, serviceWorker, clearCart]);

	return {
		currentUser: userData?.currentUser,
		loading: userLoading,
		error: userError,
		refetchUser,
		logUserOut,
	};
};
